var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fire clr" },
    [
      !_vm.obj_to_null(this.user)
        ? _c(
            "div",
            {
              staticClass:
                "user_add fs-xxl text-centr mt-5 mb-5 cursor-pointer",
            },
            [
              _c(
                "div",
                { staticClass: "add user", on: { click: _vm.add_user } },
                [
                  _c("i", {
                    staticClass: "fa add_user fa-plus-square",
                    attrs: { title: "", "data-type": "delegate_users" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Оберіть користувача")]),
                ]
              ),
            ]
          )
        : _c(
            "div",
            { staticClass: "user_to_fire mx-auto col-xs-10 col-6 mt-5" },
            [
              parseInt(_vm.form.user_id) > 0
                ? _c("user_block", {
                    key: _vm.form.user_id,
                    attrs: {
                      can_del: true,
                      del_triger: _vm.remove_fire_from_doc,
                      user_id: parseInt(_vm.form.user_id),
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _c("standart", {
        key: "fire_addon",
        attrs: {
          title: "Звільнення",
          is_active_result: false,
          is_active_problem: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }